import { render, staticRenderFns } from "./XScrollableTabs.vue?vue&type=template&id=e1def10a&"
import script from "./XScrollableTabs.vue?vue&type=script&lang=ts&"
export * from "./XScrollableTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../public-charging/admin-portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../public-charging/admin-portal/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCardTitle,VStepper,VStepperContent,VStepperItems,VTab,VTabs})
